import React from 'react';
import { cn } from '@/lib/utils';

interface ErrorMessageProps {
  message: string;
  className?: string;
}

export default function ErrorMessage({ message, className }: ErrorMessageProps) {
  return (
    <div
      className={cn(
        'bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded',
        className
      )}
    >
      <p className="text-sm">{message}</p>
    </div>
  );
}

export { ErrorMessage };
